__turbopack_context__.v({
  "fullContainer": "helpCenterListWrapper-module-scss-module__knbJhW__fullContainer",
  "halfContainer": "helpCenterListWrapper-module-scss-module__knbJhW__halfContainer",
  "header": "helpCenterListWrapper-module-scss-module__knbJhW__header",
  "helpCenterListWrapper": "helpCenterListWrapper-module-scss-module__knbJhW__helpCenterListWrapper",
  "innerList": "helpCenterListWrapper-module-scss-module__knbJhW__innerList",
  "itemBox": "helpCenterListWrapper-module-scss-module__knbJhW__itemBox",
  "itemList": "helpCenterListWrapper-module-scss-module__knbJhW__itemList",
  "itemMainBox": "helpCenterListWrapper-module-scss-module__knbJhW__itemMainBox",
  "itemMainList": "helpCenterListWrapper-module-scss-module__knbJhW__itemMainList",
  "left": "helpCenterListWrapper-module-scss-module__knbJhW__left",
  "listItems": "helpCenterListWrapper-module-scss-module__knbJhW__listItems",
  "outerList": "helpCenterListWrapper-module-scss-module__knbJhW__outerList",
  "right": "helpCenterListWrapper-module-scss-module__knbJhW__right",
  "title": "helpCenterListWrapper-module-scss-module__knbJhW__title",
});
